import {UUID} from '../../../shared/types/uuid.type';
import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, concatMap, map, tap} from 'rxjs/operators';
import {forkJoin, Observable, of} from 'rxjs';
import {MatSnackBar} from '@angular/material/snack-bar';
import {deleteManyDestinations, deleteManyDestinationsFailure, deleteManyDestinationsSuccess} from './destination.delete-many.actions';
import {DestinationsService} from '../../../services/api/destinations/destinations.service';
import {Destination} from '../../../services/api/destinations/destination.model';
import {loadDestinations, manyDestinationsDeleted} from '../actions/destinations.actions';


@Injectable()
export class DestinationDeleteManyEffects {

  // noinspection JSUnusedGlobalSymbols
  deleteManyDestinations$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(deleteManyDestinations),
        concatMap((payload: { ids: UUID[] }) => {
          const ids: UUID[] = payload.ids;
          const requests: Observable<Destination>[] = ids
            .map((destinationId: UUID): Observable<Destination> =>
              this.service.delete(destinationId)
            );

          return forkJoin(requests)
            .pipe(
              map(() => deleteManyDestinationsSuccess({ids})),
              catchError(error => of(deleteManyDestinationsFailure({error})))
            );
        }));
  });

  // noinspection JSUnusedGlobalSymbols
  deleteManyDestinationsSuccess$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(deleteManyDestinationsSuccess),
        tap(() =>
          this.snackBar.open('Destinations successfully deleted', 'Success', {duration: 3000})),
        map((data: { ids: UUID[] }) => manyDestinationsDeleted({ids: data.ids}))
      );
  });

  // noinspection JSUnusedGlobalSymbols
  deleteManyDestinationsFailure$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(deleteManyDestinationsFailure),
        tap((error: { error: any }) =>
          this.snackBar.open(`Failed to delete destinations: ${error.error}`, 'Error', {duration: 3000})),
        map(() => loadDestinations())
      );
  });

  constructor(
    private readonly actions$: Actions,
    private readonly service: DestinationsService,
    private readonly snackBar: MatSnackBar
  ) {
  }

}
